<div class="item-skeleton__title"></div>
<div class="item-skeleton__widget">
  <div class="item-skeleton__widget-value"></div>
  <div class="item-skeleton__widget-state"></div>
  <div class="item-skeleton__widget-state"></div>
</div>
